import React from 'react'

const SiteHeader = () => {
  // 🔴 A <section>, NOT A <header>. There is exactly one <header> on this page and it is the
  // house bar (TopBar.js, standard part 3). This block is the game's own hero — heading and
  // tagline — which is content rather than chrome, and leaving it as a second <header> made
  // "the header" mean two different things to any tool that asks for it.
  return (
    <section className='dvs-header'>
      <h1 className='dvs-eyebrow'><span className='dot' />Sudoku ML</h1>
      {/* 🔴 "Play Sudoku. Solve it instantly." WAS A PROMISE THE SITE NO LONGER KEEPS — the
          solution button was commented out on 22 September 2026, so the tagline now says what
          the game does: six difficulties, and every game kept in the browser. */}
      <p className='dvs-tagline'>Six difficulties. Your games are saved.</p>
    </section>
  )
}

export default SiteHeader
